import type { ReactNode } from "react"

type FieldsetProps = {
  label: string
  description?: string
  children: ReactNode
}

export const Fieldset = ({ label, description, children }: FieldsetProps) => {
  return (
    <section className="space-y-3">
      <div className="space-y-1">
        <h3 className="text-sm font-medium text-foreground">{label}</h3>
        {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
      </div>
      {children}
    </section>
  )
}
